var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.48663C2 4.14222 2.17045 3.82108 2.45321 3.63276L4.40642 2.33191C5.0709 1.88936 5.9291 1.88936 6.59358 2.33191L8.54679 3.63276C8.82955 3.82108 9 4.14222 9 4.48663V9.76215H15V4.48663C15 4.14222 15.1705 3.82108 15.4532 3.63276L17.4064 2.33191C18.0709 1.88936 18.9291 1.88936 19.5936 2.33191L21.5468 3.63276C21.8295 3.82108 22 4.14222 22 4.48663V19.9604C22 21.0868 21.1046 22 20 22H15V18.9405C15 17.2508 13.6569 15.8811 12 15.8811C10.3431 15.8811 9 17.2508 9 18.9405V22H4C2.89543 22 2 21.0868 2 19.9604V4.48663ZM8.75 12.8216C8.75 13.244 9.08579 13.5865 9.5 13.5865H14.5C14.9142 13.5865 15.25 13.244 15.25 12.8216C15.25 12.3992 14.9142 12.0567 14.5 12.0567H9.5C9.08579 12.0567 8.75 12.3992 8.75 12.8216Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortress);
export default __webpack_public_path__ + "static/media/fortress.298d992cd00981359ab567297025c960.svg";
export { ForwardRef as ReactComponent };